import { render, staticRenderFns } from "./digitalOrder.vue?vue&type=template&id=7c36cab4&"
import script from "./digitalOrder.vue?vue&type=script&lang=js&"
export * from "./digitalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports